
import React from "react";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ThankYouMessageProps {
  serviceName?: string;
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ serviceName }) => {
  return (
    <Card className="max-w-md mx-auto animate-fade-up border-green-200 shadow-md">
      <CardHeader className="text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>
        <CardTitle className="text-2xl text-green-700">Ευχαριστούμε!</CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-4">
        <p className="text-gray-600">
          {serviceName 
            ? `Η αίτησή σας για ${serviceName} υποβλήθηκε επιτυχώς.` 
            : 'Η φόρμα υποβλήθηκε επιτυχώς.'} 
          Ένας εξειδικευμένος συνεργάτης μας θα επικοινωνήσει μαζί σας σύντομα.
        </p>
        <Button variant="outline" onClick={() => window.location.href = "/"}>
          Επιστροφή στην αρχική
        </Button>
      </CardContent>
    </Card>
  );
};

export default ThankYouMessage;
